import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Image } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { MOB_ICONS, getFileLiveUrl, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import AttendanceDashboardReport from "../attendanceReport/dashboardReport";
import Footer from "../footer";
import Header from "../header";
import TodayTimeTable from "../todayTimeTable";
import UpcomingTimeTable from "../upcomingTimeTable";
import UserLinksIcons from "./UserLinksIcons";
import FeeCollectionChart from "./feeCollectionChart";
import FeeCount from "./feeCount";
import UserShortLinks from "./userShortLinks";

const Dashboard = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [birthdayWish, setBirthdayWish] = useState([]);

  const linkClick = (toUrl) => {
    navigate(toUrl);
  };

  const userPhoto = () => {
    if (
      context.user &&
      context.user.emp_profile_photo &&
      context.user.emp_profile_photo.length > 5
    )
      return getFileLiveUrl(context.user.emp_profile_photo);

    let gender = upperCase(context.user.emp_gender);
    if (gender == "MALE") return MOB_ICONS.MAN_256;
    else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
  };

  /* useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const form = new FormData();
    form.append("type", "staff");
    form.append("uuid", context.user.uuid);
    form.append("course", context.user.emp_academic_department);
    axios.post(ServiceUrl.MOB.MY_NOTIFICATION_COUNT, form).then((res) => {
      if (res["data"].status == "1") {
        if (parseInt(res["data"].data.history_count) > 0) {
          setNotificationCount(
            parseInt(res["data"].data.count) -
              parseInt(res["data"].data.history_count)
          );
        } else {
          setNotificationCount(parseInt(res["data"].data.count));
        }
      } else {
      }
      //  setLoader(false);
    });
  }; */

  const closeModal = () => {
    setShowModal(false);
  };

  /*  useEffect(() => {
    handleGetBirthdayWish();
  }, []);

  const handleGetBirthdayWish = (e) => {
    context.setLoader(true);
    var form = new FormData();
    form.append("uuid", context.user.uuid);
    axios
      .post(ServiceUrl.STUDENTS.STAFF_BIRTHDAY_WISH_TEMPLATE, form)
      .then((res) => {
        if (res["data"].status == "1" && res["data"].is_birthday == "1") {
          let d = res["data"].data;
          setBirthdayWish(d);
          setShowModal(true);
        } else {
          console.error(res["data"].message || "Error");
        }
        context.setLoader(false);
      });
    context.setLoader(false);
  }; */
  return (
    <>
      <Header noBack title="Dashboard" />
      <div className="container py-md-3">
        <Row>
          <Col md={6} className="mb-3">
            <Card sx={{ display: "flex" }} className="profile_card_bg p-0">
              <CardMedia
                component="img"
                sx={{ width: 120 }}
                src={userPhoto()}
              />
              <Box
                className="ms-2"
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <CardContent sx={{ flex: "1 0 auto" }}>
                  <Typography
                    component="div"
                    variant="h5"
                    className="fw-bolder"
                    style={{ fontSize: "18px" }}
                  >
                    {context.user.employee_name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="div"
                    style={{ fontSize: "14px" }}
                    sx={{ color: "black" }}
                  >
                    {context?.user?.designation_name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    style={{ fontSize: "12px" }}
                    component="div"
                    sx={{ color: "secondary.text" }}
                  >
                    {context.user.emp_official_mail}
                  </Typography>
                </CardContent>
                <Box
                  sx={{ display: "flex", alignItems: "center", pl: 1, pb: 1 }}
                ></Box>
              </Box>
            </Card>
          </Col>

          {context.allowedAccess(
            "mob_fee_collection_reports",
            "action_list"
          ) && (
            <Col md={6} className="mb-3">
              <FeeCount />
            </Col>
          )}

          {context.allowedAccess(
            "mob_fee_collection_reports",
            "action_list"
          ) && (
            <Col md={6} className="mb-3">
              <FeeCollectionChart />
            </Col>
          )}

          <Col md={6} className="mb-3">
            <UserLinksIcons />
          </Col>

          {context.allowedAccess(
            "mob_class_attendance_marked_report",
            "action_list"
          ) && (
            <Col md={6} className="mb-3">
              <AttendanceDashboardReport />
            </Col>
          )}
        </Row>
        <Row className="">
          <Col md={6} className="mb-3">
            {(!context.user.role_uid ||
              context.allowedAccess(
                "mob_student_attendance",
                "action_create"
              )) && (
              <>
                <TodayTimeTable withGeneral={true} />
                <div className="divider t-12 b-20"></div>
              </>
            )}
          </Col>
          <Col md={6} className="mb-3">
            {context.allowedAccess(
              "mob_view_upcoming_timetable",
              "action_read"
            ) && (
              <>
                <UpcomingTimeTable upComing={true} />
                <div className="divider t-12 b-20"></div>
              </>
            )}
          </Col>
        </Row>

        <Row>
          <Col md={6} data-aos="zoom-in">
            {/* <Correspondentlink /> */}
          </Col>
        </Row>

        <div className="py-3"></div>
      </div>
    </>
  );
  return (
    <>
      <Header noBack />
      <div className="">
        <div className="container">
          <div class="card user-info-card " data-aos="zoom-in">
            <div class="card-body p-2 d-flex align-items-center">
              <div class="user-profile me-3">
                <Image
                  src={userPhoto()}
                  width={74}
                  height={74}
                  fallback={MOB_ICONS.NO_USER_250.default}
                  className="ms-auto me-auto shadow-sm"
                />
              </div>
              <div class="user-info">
                <h5 class="mb-0">{context.user.employee_name}</h5>
                <div>{context?.user?.designation_name}</div>
                <p class="mb-0 text-dark">{context.user.emp_official_mail}</p>
              </div>
              <a onClick={(e) => linkClick("/staff/app/notification")}>
                <div class="notification-container">
                  <img
                    src={MOB_ICONS.BELL}
                    style={{ width: "37px" }}
                    class="notification-icon"
                    alt="Notification Icon"
                  />

                  {notificationCount > 0 ? (
                    <>
                      <span class="notification-count">
                        {notificationCount}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>{" "}
              </a>
            </div>
          </div>

          <UserShortLinks />
          <div className="divider t-12 b-20"></div>

          {context.allowedAccess(
            "mob_fee_collection_reports",
            "action_list"
          ) && (
            <>
              <FeeCount />
              <div className="divider t-12 b-20"></div>
            </>
          )}
          {context.allowedAccess(
            "mob_class_attendance_marked_report",
            "action_list"
          ) && (
            <>
              <AttendanceDashboardReport />
              <div className="divider t-12 b-20"></div>
            </>
          )}
        </div>
        <div className="container-fluid">
          {(!context.user.role_uid ||
            context.allowedAccess(
              "mob_student_attendance",
              "action_create"
            )) && (
            <>
              <TodayTimeTable withGeneral={true} />
              <div className="divider t-12 b-20"></div>
            </>
          )}
          {context.allowedAccess(
            "mob_view_upcoming_timetable",
            "action_read"
          ) && (
            <>
              <div className="mt-3"></div>
              <UpcomingTimeTable upComing={true} />
              <div className="divider t-12 b-20"></div>
            </>
          )}
        </div>
      </div>
      <Footer />

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "rgb(201 255 242)",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "500px",
              width: "100%",
              position: "relative", // Ensure the close icon is positioned relative to the modal
              textAlign: "center",
            }}
          >
            <span
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              &times;
            </span>
            <img
              src={MOB_ICONS.BIRTHDAY}
              alt="Birthday Icon"
              style={{
                width: "100px", // Adjust the size of the circle as needed
                height: "100px",
                borderRadius: "50%", // Makes the image a circle
                objectFit: "cover", // Ensures the image covers the circle shape
                marginBottom: "20px", // Adds space between the image and the text
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
            <h2 style={{ fontFamily: "arial-black" }}>Happy Birthday!</h2>
            <h6 style={{ fontFamily: "arial-black" }}>
              {birthdayWish.template_msg}
            </h6>
          </div>
        </div>
      )}
    </>
  );
};
export default Dashboard;
